import {
  DestinationStatusEnum,
  DestinationTypeEnum,
} from "../../../enums/destination";
import {
  AllDestinations,
  ShopifyDestination,
  WordPressDestination,
} from "../../../models";
import { ensureTrailingSlash } from "../../../utils";
import { secretKeyMask } from "./formValidationUtils";

export const generatePayload = (
  destination: AllDestinations,
  values: any,
  accountId: string
): AllDestinations => {
  const payload: any = {
    ...values,
    accountId,
    destination: {
      ...values.destination,
    },
  };

  delete payload.createdAt;
  delete payload.updatedAt;

  if (payload.destination.secretKey?.startsWith(secretKeyMask)) {
    payload.destination.secretKey = payload.destination.secretKey.replace(
      secretKeyMask,
      ""
    );
  }

  if (values.destinationTypeId === DestinationTypeEnum.GOOGLE_DOCS) {
    // no typed secret: the server keeps the token, email and folder from the Google connect flow
    delete payload.destination.secretKey;
    return payload;
  }

  if (values.destinationTypeId === DestinationTypeEnum.WORDPRESS) {
    payload.url = ensureTrailingSlash(values.destination.url);
    payload.destination.postDelayHours =
      values.destination.status === DestinationStatusEnum.FUTURE
        ? values.destination.postDelayHours
        : null;
    payload.destination.randomPostHours =
      values.destination.status === DestinationStatusEnum.FUTURE
        ? values.destination.randomPostHours
        : null;
  }

  if (values.destinationTypeId === DestinationTypeEnum.SHOPIFY) {
    payload.destination.storeName = values.destination.storeName;
  }

  if (values.destinationId) {
    // if secret key is empty, reset to original
    if (!payload.destination.secretKey) {
      payload.destination.secretKey = (
        destination as WordPressDestination | ShopifyDestination
      ).destination.secretKey;
    }
  }

  return payload;
};
